import React from "react";

import '../../assets/styles/SeparatorTitle.css';

const SeparatorTitle = ({ question }) => {
    return <div key={question.sym_id} className="SeparatorTitle">
                <h3 className="m-0">{question.label}</h3>
                {question.sublabel && <p>{question.sublabel}</p>}
            </div>;
};

export default SeparatorTitle;
